export default __webpack_public_path__ + "static/media/coupouapplied_shower.9e9a84b8.svg";